"use client";

import { MagnifyingGlassIcon } from "@heroicons/react/24/solid";
import { useState } from "react";
import { twMerge } from "tailwind-merge";

import { SelectCoverModal } from "@/components/fileCoverInput/inputMethods/coverUpload/selectCoverModal/SelectCoverModal";
import { useSetAuthModalOpen } from "@/lib/clerk/useSetAuthModalOpen";
import { AudioInputState, UserNoDates } from "@/types/types";

export function CoverUpload({
  adjustAcoustic,
  showSelectCoverText,
  user,
  checkSubscription,
  setInvalidLengthSubscriptionModalOpen,
  audioLengthMinLimitMinutes,
  audioLengthMaxLimitMinutes,
  setInvalidLengthMaxModalOpen,
  showCover,
  setInputCover,
  className,
}: {
  adjustAcoustic: boolean | null;
  showSelectCoverText: boolean | null;
  user: UserNoDates | null;
  checkSubscription: boolean;
  setInvalidLengthSubscriptionModalOpen: (value: boolean) => void;
  audioLengthMinLimitMinutes: number | null;
  audioLengthMaxLimitMinutes: number;
  setInvalidLengthMaxModalOpen: (value: boolean) => void;
  showCover: boolean;
  setInputCover: AudioInputState["setInputCover"];
  className?: string;
}) {
  const [selectCoverModalOpen, setSelectCoverModalOpen] = useState(false);

  const setAuthModalOpen = useSetAuthModalOpen();

  return (
    <>
      <SelectCoverModal
        open={selectCoverModalOpen}
        closeModal={() => setSelectCoverModalOpen(false)}
        adjustAcoustic={adjustAcoustic}
        showSelectCoverText={showSelectCoverText}
        user={user}
        checkSubscription={checkSubscription}
        setInvalidLengthSubscriptionModalOpen={
          setInvalidLengthSubscriptionModalOpen
        }
        audioLengthMinLimitMinutes={audioLengthMinLimitMinutes}
        audioLengthMaxLimitMinutes={audioLengthMaxLimitMinutes}
        setInvalidLengthMaxModalOpen={setInvalidLengthMaxModalOpen}
        showCover={showCover}
        setInputCover={setInputCover}
      />
      <button
        data-testid="select-cover-button"
        onClick={() => {
          if (user === null) {
            setAuthModalOpen();
            return;
          }

          setSelectCoverModalOpen(true);
        }}
        className={twMerge(
          "flex w-full rounded-full border-0 py-4 pr-8 text-left text-gray-400 shadow-sm ring-1 ring-inset ring-primary transition-all hover:ring-primaryLight",
          className
        )}
      >
        <div className="mr-2 flex items-center pl-4">
          <MagnifyingGlassIcon className="h-6 w-6 shrink-0 fill-gray-400" />
        </div>
        Type any song
      </button>
    </>
  );
}
